import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Client auth/session slice — persisted like legacy redux-persist authStore. */
export const useAuthStore = create(
  persist(
    (set) => ({
      currentUser: {},
      isAuthenticated: false,
      loading: false,
      error: false,
      setSession: (user) =>
        set({
          currentUser: user,
          isAuthenticated: true,
          loading: false,
          error: false,
        }),
      setSessionError: () =>
        set({
          loading: false,
          error: true,
          isAuthenticated: false,
          currentUser: {},
        }),
      clearSession: () =>
        set({
          currentUser: {},
          isAuthenticated: false,
          loading: false,
          error: false,
        }),
    }),
    {
      name: 'festy-auth',
      partialize: (state) => ({
        currentUser: state.currentUser,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
